import React from 'react';
import { Flex, Text } from '@chakra-ui/react';

export const NoGame = ({ reason }: { reason: string }) => (
	<Flex
		minH="100vh"
		justifyContent="center"
		alignItems="center"
	>
		<Text
			fontSize="20px"
			fontWeight="600"
		>
			{reason}
		</Text>
	</Flex>
);
